"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgileBotAddedChannelCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const _1 = require(".");
const TITLE = "👋 Hi There! Welcome to AgilePolly";
const MESSAGE = "A teammate of yours recently added me to help your team run standups.";
const AgileBotAddedChannelCard = () => {
    const card = CardHelper_1.CardHelper.newCard();
    const container = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
        spacing: adaptivecards_1.Spacing.ExtraLarge,
        style: adaptivecards_1.ContainerStyle.Emphasis,
    });
    container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        color: adaptivecards_1.TextColor.Accent,
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
        size: adaptivecards_1.TextSize.Large,
        text: TITLE,
        weight: adaptivecards_1.TextWeight.Bolder,
        wrap: true,
    }));
    container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        color: adaptivecards_1.TextColor.Accent,
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
        size: adaptivecards_1.TextSize.Medium,
        text: MESSAGE,
        wrap: true,
    }));
    card.addItem(container);
    card.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.OpenUrlAction, {
        title: "Learn more",
        url: _1.AGILE_LEARN_MORE_LINK,
    }));
    return card;
};
exports.AgileBotAddedChannelCard = AgileBotAddedChannelCard;
//# sourceMappingURL=AgileBotAddedChannelCard.js.map